module.exports = __webpack_public_path__ + "static/media/header3.6bd6058e.png";